import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";

export const GET_GRP_TARGETS = "get_grp_targets";
export const GET_GRP_TARGET_POPULATIONS = "get_grp_target_populations";
export const CREATE_GRP_TARGET = "create_grp_target";
export const UPDATE_GRP_TARGET = "update_grp_target";
export const DELETE_GRP_TARGET = "delete_grp_target";

@Component
export default class GrpTargetMixin extends Vue {
  getTargets() {
    const grp_path = `${API_ENDPOINT}/me/grp/targets.json`;
    return this.$store.dispatch("http/request", {
      tag: GET_GRP_TARGETS,
      url: grp_path,
      method: "GET",
    });
  }
  getTargetPopulation(data: any) {
    const grp_path = `${API_ENDPOINT}/me/grp/targets/${data.id}/populations.json?start=${data.start}&end=${data.end}`;
    return this.$store.dispatch("http/request", {
      tag: GET_GRP_TARGET_POPULATIONS,
      url: grp_path,
      method: "GET",
    });
  }
  createTarget(data: any) {
    const grp_path = `${API_ENDPOINT}/me/grp/targets.json`;
    return this.$store.dispatch("http/request", {
      tag: CREATE_GRP_TARGET,
      url: grp_path,
      method: "POST",
      data: data,
    });
  }
  updateTarget(id: string, name: string) {
    const grp_path = `${API_ENDPOINT}/me/grp/targets/${id}.json`;
    return this.$store.dispatch("http/request", {
      tag: UPDATE_GRP_TARGET,
      url: grp_path,
      method: "PUT",
      data: {
        name: name,
      },
    });
  }
  deleteTarget(id: string) {
    const grp_path = `${API_ENDPOINT}/me/grp/targets/${id}.json`;
    return this.$store.dispatch("http/request", {
      tag: DELETE_GRP_TARGET,
      url: grp_path,
      method: "DELETE",
    });
  }
}
